import React from 'react';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';

/**
 * A number beside a label, e.g. a tab's record count. Same size and type as
 * the theme's Badge (the number on the sync icon): 20px tall, 12px semi-bold,
 * tabular figures. Green when it belongs to the selected item.
 */
const CountBadge = ({ count, active = false }) => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 20,
      height: 20,
      px: 0.75,
      borderRadius: 10,
      fontSize: '0.75rem',
      fontWeight: 600,
      lineHeight: 1,
      fontVariantNumeric: 'tabular-nums',
      color: active ? 'primary.main' : 'text.secondary',
      bgcolor: (theme) => (active ? alpha(theme.palette.primary.main, 0.12) : alpha(theme.palette.text.primary, 0.08)),
    }}
  >
    {count}
  </Box>
);

export default CountBadge;
